import { Box, Tooltip } from "@mui/material";
import { palette } from "../../styles/theme";
import type { SpecsLayerView } from "./types";
import { useSpecsEditorContextValue } from "./useSpecsEditor";

const LAYER_VIEWS: SpecsLayerView[] = [
  "highlight",
  "mask",
  "preview",
  "global",
];

const LAYER_VIEW_LABELS: Record<SpecsLayerView, string> = {
  highlight: "Highlight",
  mask: "Masque",
  preview: "Layer",
  global: "Global",
};

const LAYER_VIEW_TOOLTIPS: Record<SpecsLayerView, string> = {
  highlight: "Highlight du layer",
  mask: "Masque du layer",
  preview: "Masque et Highlight du layer",
  global: "Masque et Highlight global",
};

export default function SpecsLayerViewToggle() {
  const { editor, effectiveLayerView } = useSpecsEditorContextValue();

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: palette.grey.lightBackground,
        borderRadius: "8px",
        p: "3px",
        gap: "2px",
      }}
    >
      {LAYER_VIEWS.map((view) => (
        <Tooltip key={view} title={LAYER_VIEW_TOOLTIPS[view]}>
          <Box
            component="button"
            onClick={() => editor.setLayerView(view)}
            sx={{
              px: 2,
              py: 0.75,
              border: 0,
              borderRadius: "6px",
              bgcolor: effectiveLayerView === view ? "white" : "transparent",
              color:
                effectiveLayerView === view ? "text.primary" : "text.secondary",
              fontWeight: effectiveLayerView === view ? 600 : 500,
              fontSize: "13px",
              cursor: "pointer",
              transition: "all 0.15s",
              boxShadow:
                effectiveLayerView === view
                  ? "0 1px 3px rgba(0,0,0,0.08)"
                  : "none",
              "&:hover": {
                color: "text.primary",
              },
            }}
          >
            {LAYER_VIEW_LABELS[view]}
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
}
